module.exports = __webpack_public_path__ + "media/images/icons/outlined/calendar-08a5c8a0fe284d62d796405950c45d94.svg";